<div class="rhtoolbar">
  <ul class="rhtoolbar__actions">
    <li class="rhtoolbar__actionsitem">
      <a target="_blank" href="https://docs.festivalscope.com/RH/guide/rh_guide.html">
        <div class="rhtoolbar__action rhtoolbar__action--rightsholders">
          <span>{{ 'fspro.front.rights_holders' | translate }}</span>
        </div>
      </a>
      <div class="link-underline-mobile " [ngClass]="{'link-underline' : isActive('/')}"></div>
    </li>
    <li class="rhtoolbar__actionsitem" [class.rhtoolbar__actionsitem--open]="isToggleToolbar">
      <a routerLink="/rh/my-films" [ngClass]="{'rh-item-menu-selected ' : isActive('/rh/my-films')}"
       class="rhtoolbar__action rhtoolbar__action--myfilms">{{'fspro.front.rhlu.toolbar.my_films' | translate }}</a>
      <div class="link-underline-mobile " [ngClass]="{'link-underline' : isActive('/rh/my-films')}"></div>
    </li>
    <li class="rhtoolbar__actionsitem" [class.rhtoolbar__actionsitem--open]="isToggleToolbar">
      <a routerLink="/rh/booking-requests" class="rhtoolbar__action rhtoolbar__action--bookingrequests">
        <div class="rh-item-menu" [ngClass]="{'rh-item-menu-selected' : isActive('/rh/booking-requests')}">
          <span>{{'fspro.front.rhlu.toolbar.booking_request' | translate }}</span>
        </div>
        <div class="counter-container" [ngClass]="{'counter-container-selected ' : isActive('/rh/booking-requests')}" *ngIf="notificationsFacade.pendingBookingRequestRequest$ | async as noOfBooking"><span>{{ noOfBooking
            }}</span> </div>
      </a>
      <div class="link-underline-mobile with-icon" [ngClass]="{'link-underline' : isActive('/rh/booking-requests')}"></div>
    </li>
    <li class="rhtoolbar__actionsitem" [class.rhtoolbar__actionsitem--open]="isToggleToolbar">
      <a routerLink="/rh/invitations/sent" [ngClass]="{'rh-item-menu-selected ' : isActive('/rh/invitations/sent')}" class="rhtoolbar__action rhtoolbar__action--invites">{{'fspro.front.rhlu.toolbar.sent_invites' | translate
        }}</a>
      <div class="link-underline-mobile" [ngClass]="{'link-underline' : isActive('/rh/invitations/sent')}"></div>
    </li>
    <li class="rhtoolbar__actionsitem" [class.rhtoolbar__actionsitem--open]="isToggleToolbar">
      <a routerLink="/rh/screening-reports" [ngClass]="{'rh-item-menu-selected ' : isActive('/rh/screening-reports')}" class="rhtoolbar__action rhtoolbar__action--reports">{{'fspro.front.rhlu.toolbar.all_reports' | translate
        }}</a>
      <div class="link-underline-mobile" [ngClass]="{'link-underline' : isActive('/rh/screening-reports')}"></div>
    </li>
    <li class="rhtoolbar__actionsitem" [class.rhtoolbar__actionsitem--open]="isToggleToolbar">
      <a routerLink="/rh/screening-requests" class="rhtoolbar__action rhtoolbar__action--requests">
        <div class="rh-item-menu" [ngClass]="{'rh-item-menu-selected ' : isActive('/rh/screening-requests')}">
          {{'fspro.front.rhlu.toolbar.all_request' | translate }}
        </div>
        <div *ngIf="notificationsFacade.pendingScreeningRequest$ | async as pendingScreeningRequest" [ngClass]="{'counter-container-selected' : isActive('/rh/screening-requests')}" class="counter-container">
          <span>{{ pendingScreeningRequest }}</span>
        </div>
      </a>
      <div class="link-underline-mobile with-icon" [ngClass]="{'link-underline' : isActive('/rh/screening-requests')}"></div>
    </li>
    <li class="rhtoolbar__actionsitem" [class.rhtoolbar__actionsitem--open]="isToggleToolbar">
      <a routerLink="/rh/my-contacts" class="rhtoolbar__action rhtoolbar__action--mycontacts">
        <div class="rh-item-menu" [ngClass]="{'rh-item-menu-selected ' : isActive('/rh/my-contacts')}">
          {{'fspro.front.rhlu.toolbar.my_contacts' | translate }}
        </div>
      </a>
      <div class="link-underline-mobile with-icon" [ngClass]="{'link-underline' : isActive('/rh/my-contacts')}"></div>
    </li>
    <li class="rhtoolbar__actionsitem" [class.rhtoolbar__actionsitem--open]="isToggleToolbar">
      <a *ngIf="!(notificationsFacade.filmsAvailableForInvitation$ | async)" class="rhtoolbar__action rhtoolbar__action--invite" (mouseenter)="displayInviteTooltipToggle()" (mouseleave)="displayInviteTooltipClose()">{{'fspro.front.rhlu.toolbar.invite' | translate }}</a>
      <a *ngIf="notificationsFacade.filmsAvailableForInvitation$ | async" class="rhtoolbar__action rhtoolbar__action--invite" routerLink="/rh/invitation/autoselect/form" class="rhtoolbar__action rhtoolbar__action--invite rhtoolbar__action--highlight">
        <div class="rh-item-menu" [ngClass]="{'rh-item-menu-selected ' : isActive('/rh/invitation/autoselect/form')}">
          <div class="icon-container"><lucide-icon class="icon-mail-plus" size="14" name="mail-plus"></lucide-icon></div>
          <div>{{'fspro.front.rhlu.toolbar.invite'| translate }}</div>
        </div>
      </a>
      <div class="no-film-invitation-notification" *ngIf="displayInviteTooltip">
        {{'fspro.front.rhlu.toolbar.invite.no_film_for_screening' | translate }}
      </div>
      <div class="link-underline-mobile with-icon" [ngClass]="{'link-underline' : isActive('/rh/invitation/autoselect/form')}"></div>
    </li>
  </ul>
</div>
